import React, { memo, ReactElement } from 'react'
import { Button } from '@elamajs/ui-kit'
import { getSvg } from '@src/containers/UtmGenerator/helpers'

import * as Styled from './Copy.styled'

type Props = {
  text: string
  getAnalyticClick?: () => void
}

function Copy({ text, getAnalyticClick }: Props): ReactElement {
  const handleClick = () => {
    getAnalyticClick && getAnalyticClick()
    navigator.clipboard && navigator.clipboard.writeText(text)
  }

  return (
    <Styled.CopyButton as={Button} onClick={handleClick}>
      {getSvg('copy')}
    </Styled.CopyButton>
  )
}

export default memo(Copy)
